import { render, staticRenderFns } from "./LogoSmall.vue?vue&type=template&id=413ba026&"
import script from "./LogoSmall.vue?vue&type=script&lang=js&"
export * from "./LogoSmall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports